
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...segments]]",
      function () {
        return require("private-next-pages/[[...segments]].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...segments]]"])
      });
    }
  